"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ListWorkflowTodosResponse () {
        return ListWorkflowTodosResponse;
    },
    get ListWorkflowsResponse () {
        return ListWorkflowsResponse;
    },
    get WORKFLOW_TODO_STATUSES () {
        return WORKFLOW_TODO_STATUSES;
    },
    get WorkflowTodoStatusSchema () {
        return WorkflowTodoStatusSchema;
    }
});
const _zod = require("zod");
const _responsehelpers = require("../helpers/response-helpers");
const WorkflowSubjectResponse = _zod.z.object({
    _id: _responsehelpers.ResponseObjectId,
    name: _zod.z.string()
});
const WorkflowResponseItem = _zod.z.object({
    _id: _responsehelpers.ResponseObjectId,
    name: _zod.z.string(),
    startDate: _zod.z.date(),
    subject: WorkflowSubjectResponse.nullable(),
    totalTodoCount: _zod.z.number().int(),
    completedTodoCount: _zod.z.number().int(),
    overdueTodoCount: _zod.z.number().int(),
    unassignedTodoCount: _zod.z.number().int(),
    completed: _zod.z.boolean()
});
const ListWorkflowsResponse = _zod.z.object({
    workflows: _zod.z.array(WorkflowResponseItem),
    totalCount: _zod.z.number().int()
});
const WORKFLOW_TODO_STATUSES = [
    "active",
    "completed",
    "overdue"
];
const WorkflowTodoStatusSchema = _zod.z.enum(WORKFLOW_TODO_STATUSES);
const WorkflowTodoReferenceResponse = _zod.z.object({
    _id: _responsehelpers.ResponseObjectId,
    name: _zod.z.string()
});
const WorkflowTodoResponseItem = _zod.z.object({
    _id: _responsehelpers.ResponseObjectId,
    action: _zod.z.string(),
    subject: WorkflowTodoReferenceResponse.nullable(),
    actor: WorkflowTodoReferenceResponse.nullable(),
    workflow: WorkflowTodoReferenceResponse.nullable(),
    dueDate: _zod.z.date(),
    completedDate: _zod.z.date().nullable(),
    status: WorkflowTodoStatusSchema
});
const ListWorkflowTodosResponse = _zod.z.object({
    todos: _zod.z.array(WorkflowTodoResponseItem),
    totalCount: _zod.z.number().int()
});
